(() => {
  if (window.__siennaCartSync || window.Shopify?.designMode) return;
  window.__siennaCartSync = true;
  const root = window.Shopify?.routes?.root || '/';
  let dirty = true;
  let busy = false;
  let generation = 0;
  let timer;
  let lastSignature = '';
  let lastSent = 0;
  const allowed = () => window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const absolute = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' ? url.href : '';
    } catch { return ''; }
  };
  const bounded = (promise) => {
    let timeout;
    return Promise.race([
      promise,
      new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('timeout')), 8000); })
    ]).finally(() => clearTimeout(timeout));
  };
  const schedule = () => {
    dirty = true;
    generation += 1;
    clearTimeout(timer);
    timer = setTimeout(sync, 350);
  };
  async function sync() {
    if (busy || !dirty || document.visibilityState === 'hidden' || !allowed()) return;
    const klaviyo = window.klaviyo;
    if (!klaviyo || typeof klaviyo.isIdentified !== 'function') return;
    busy = true;
    const revision = generation;
    try {
      if (!await bounded(klaviyo.isIdentified())) return;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      let cart;
      try {
        const response = await fetch(root + 'cart.js', {
          credentials: 'same-origin', cache: 'no-store', signal: controller.signal
        });
        if (!response.ok) throw new Error('cart unavailable');
        cart = await response.json();
      } finally { clearTimeout(timeout); }
      if (!Array.isArray(cart.items) || revision !== generation || !allowed()) return;
      const items = cart.items.filter(item => item.quantity > 0).map(item => ({
        title: String(item.product_title || item.title || 'Your Sienna selection'),
        variant: item.variant_title === 'Default Title' ? '' : String(item.variant_title || ''),
        quantity: item.quantity,
        variant_id: String(item.variant_id || item.id),
        url: absolute(item.url),
        image_url: absolute(item.featured_image?.url || item.image)
      }));
      const count = items.reduce((sum, item) => sum + item.quantity, 0);
      const signature = JSON.stringify(items);
      if (signature !== lastSignature || Date.now() - lastSent > 3600000) {
        if (!await bounded(klaviyo.isIdentified()) || !allowed() || revision !== generation) return;
        await bounded(klaviyo.identify({
          SiennaCartItems: items,
          SiennaCartCount: count,
          SiennaCartURL: new URL(root + 'cart', location.origin).href,
          SiennaCartUpdatedAt: new Date().toISOString(),
          SiennaCartSchema: 1
        }));
        lastSignature = signature;
        lastSent = Date.now();
      }
      if (revision === generation) dirty = false;
    } catch {
      dirty = true;
    } finally {
      busy = false;
      if (revision !== generation) {
        clearTimeout(timer);
        timer = setTimeout(sync, 350);
      }
    }
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }
  if (window.PerformanceObserver) {
    try {
      new PerformanceObserver(list => {
        if (list.getEntries().some(entry => {
          const url = new URL(entry.name, location.origin);
          return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
        })) schedule();
      }).observe({ type: 'resource', buffered: false });
    } catch {}
  }
  document.addEventListener('visitorConsentCollected', schedule);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') schedule();
  });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('klaviyoForms', event => {
    if (event.detail?.type === 'submit') schedule();
  });
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], schedule);
  }
  setInterval(() => { if (dirty) sync(); }, 15000);
  schedule();
})();
